/**
 * @desc 批量审批
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(body: defs.tms.ApproveBatchRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/customsDeclarationMaster/approveBatch`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
